// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"styles_text-gradient__1BXQP","logo":"styles_logo__22loG","logoText":"styles_logoText__qABrJ"};